import { GetContextMenuItems } from '@ag-grid-community/core';
import { expandAllColumns } from './modules/expand-all-columns';
import { markAsInvestigated } from './modules/mark-as-investigated';
import { openPropertyInNewTab } from './modules/open-property-in-new-tab';
import { resetAllColumns } from './modules/reset-all-columns';
import { ContextMenuItemsExtensions } from './types';

export interface TableContextMenuItemsFeatureFlags {
  propertyTaxTab: boolean;
}

export function contextMenuMaker(
  place: string,
  featureFlags: TableContextMenuItemsFeatureFlags,
  extensions?: ContextMenuItemsExtensions
): GetContextMenuItems {
  return (params) => {
    const menuItems = [
      openPropertyInNewTab(params, place, featureFlags.propertyTaxTab),
    ];

    const investigatedMenuItem = markAsInvestigated(
      params,
      extensions?.onMarkAsInvestigated
    );

    if (investigatedMenuItem) {
      menuItems.push(investigatedMenuItem);
    }

    return [
      ...menuItems,
      expandAllColumns(params),
      resetAllColumns(params),
      ...(params.defaultItems ?? []),
    ];
  };
}
